import { TechnomanLiveData } from "./TechnomanLiveData";
import { TechnomanJourney } from "./TechnomanJourney";
import { TabView, TabPanel } from 'primereact/tabview';


export const TechnoManMain = () => {
    return (
        <>
            <div className="card">
                <TabView>
                    <TabPanel header=" Journey Data">
                        <TechnomanJourney />
                    </TabPanel>
                    <TabPanel header="Tracking Data">
                        <TechnomanLiveData />
                    </TabPanel>
                </TabView>
            </div>
        </>
    )
}
